import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';
import dayjs from 'dayjs';
import { styled } from '@mui/material/styles';
import { useLazyTransactionOfflineForPaymentQuery } from '../../services/paymentTransaction';
import SortableTableLabel from '../../components/Table/SortableTableLabel';
import { useTranslation } from 'react-i18next';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function OfflinePayment() {
  const { t } = useTranslation();
  const columns = [
  { id: 'invoice_no', label: t('app.invoiceNo'), minWidth: 100 },
  {
    id: 'start_date',
    label: t('app.startDate'),
    minWidth: 100,
    align: 'right',
  },
  {
    id: 'due_date',
    label: t('app.endDate'),
    minWidth: 100,
    align: 'right',
  },
  {
    id: 'customer_code',
    label: t('app.customerID'),
    minWidth: 100,
    align: 'right',
  },
  {
    id: 'customer_name',
    label:t('app.customerName'),
    minWidth: 100,
    align: 'right',
  },
];
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0); // sorgcode = INET
  const [sortBy, setSortBy] = useState('invoice_no');
  const [sortOrder, setSortOrder] = useState('asc');
  const [dataRowDetail, setDataRowDetail] = useState();
  const [invoiceNo, setInvoiceNo] = useState('');
  const merchant = useSelector((state) => state.merchant.value);

  const handleChangeInvoceNo = (event) => {
    setInvoiceNo(event.target.value);
  };

  const [transactionOfflineForPayment] =
    useLazyTransactionOfflineForPaymentQuery();

  const searchInoviceOffline = async () => {
    try {
      const { data } = await transactionOfflineForPayment({
        invoiceNo: invoiceNo || '',
        sorgcode: merchant || '',
      });
      // console.log('data', data);
      if (data?.message === 'OK') {
        setDataRowDetail(data?.data);
      } else {
        alert(data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    setRowsPerPage(newRowsPerPage);
    setPage(0); // ตั้งค่าหน้าเริ่มต้นเป็นหน้าที่ 0 เมื่อเปลี่ยนแถวต่อหน้า
  };

  const handleClear = () => {
    setInvoiceNo('');
  };

  const handleRequestSort = (property) => {
    setSortOrder(
      sortBy === property && sortOrder === 'asc' ? 'desc' : 'asc',
    );
    setSortBy(property);
    setPage(0);
  };

  const sortedRows = [...(dataRowDetail || [])].sort((left, right) => {
    const comparison = String(left[sortBy] ?? '').localeCompare(
      String(right[sortBy] ?? ''),
      undefined,
      { numeric: true, sensitivity: 'base' },
    );
    return sortOrder === 'asc' ? comparison : -comparison;
  });
  const paginatedRows = sortedRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  return (
    <div>
      <div className="my-2 ml-2">
        <div className="">
          <div className="lg:w-3/4 w-1/2 font-bold">
            {t('app.offlinePaymentTransactions')}
          </div>

          <div className="mt-5 flex">
            <div className="w-[350px] ">
              {' '}
              <TextField
                id="outlined-basic"
                label="กรุณากรอก Invoice No."
                size="small"
                variant="outlined"
                value={invoiceNo}
                sx={{ width: '100%' }}
                onChange={handleChangeInvoceNo}
                InputProps={{
                  endAdornment: invoiceNo && (
                    <InputAdornment position="end">
                      <IconButton onClick={handleClear} edge="end">
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>
            <div className="ml-5">
              {' '}
              <Button
                variant="contained"
                sx={{ color: 'white' }}
                onClick={searchInoviceOffline}
              >
               {t('app.search') }
              </Button>{' '}
            </div>{' '}
          </div>
        </div>
      </div>
      <div className="mt-2">
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
       <TableContainer sx={{ overflowX: 'auto', overflowY: 'visible' }}>

            <Table size='small'>
              <TableHead>
                <StyledTableRow>
                  {columns.map((column) => (
                    <StyledTableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      <div style={{ whiteSpace: 'nowrap', padding: 5 }}>
                        <SortableTableLabel
                          column={column}
                          sortBy={sortBy}
                          sortOrder={sortOrder}
                          onSort={handleRequestSort}
                          color="white"
                        />
                      </div>
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              </TableHead>
              {_.size(dataRowDetail) ? (
                <TableBody>
                  {paginatedRows.length > 0 &&
                    _.map(paginatedRows, (item, index) => (
                      <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                        {columns.map((column) => {
                          const value = item[column.id];

                          if (column.id === 'customer_name') {
                            return (
                              <TableCell align={column.align}>
                                {value}
                              </TableCell>
                            );
                          }

                          if (column.id === 'start_date') {
                            return (
                              <TableCell align={column.align}>
                                {dayjs(value).format('YYYY MMMM DD')}
                              </TableCell>
                            );
                          }
                          if (column.id === 'due_date') {
                            return (
                              <TableCell align={column.align}>
                                {dayjs(value).format('YYYY MMMM DD')}
                              </TableCell>
                            );
                          }

                          return (
                            <TableCell key={column.id} align={column.align}>
                              {value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      <div>{t('app.noDataAvailable')}</div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[5, 25, 100]}
            component="div"
            count={dataRowDetail ? dataRowDetail.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    </div>
  );
}

export default OfflinePayment;
